import React from "react";
import GenericMSDSFilesListing from "./GenericMSDSFilesListing";

function NotReadOnlyMSDSFilesListing() {
  return (
    <GenericMSDSFilesListing readOnly = {false}   />
  );
}

export default NotReadOnlyMSDSFilesListing;